import { useState, useEffect, useRef, useMemo } from "react";
import React from "react";
import "../Home/Home.css";
import "./MyAccount.css";
import { AdminHeader } from "../Header/AdminHeader";
import { AdminSidebar } from "../Sidebar/AdminSidebar";
import { hasPermission, permissionConfig } from "_helpers/permissions";

import { useDispatch } from "react-redux";
import { authActions, store } from "_store";
import { getUserDetails } from "_services/userCreationApi";
import LoadingOverlay from "_components/overlay/LoadingOverlay";
import SimpleTable from "_components/SimpleTable";

export { MyAccount };

function MyAccount() {
  const dispatch = useDispatch();
  const logout = () => dispatch(authActions.logout());
  const adminAccess = hasPermission(permissionConfig.adminAccess);
  const [userData, setUserData] = useState({});
  const [loader, setLoader] = useState(false);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.clientHeight);
    }
  }, [userData]);

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      const userId = store.getState().auth.value?.id;
      setLoader(true);
      if (userId) {
        const userDetails = await getUserDetails(userId, adminAccess);
        if (userDetails?.success) {
          if(adminAccess) {
            setUserData(userDetails?.data.data);
          } else {
            setUserData(userDetails?.data);
          }
        }
      }
      setLoader(false);
    };
    fetchDropdownOptions();
  }, []); 

  const [supplierListOpen, setSupplierListOpen] = useState(false);
  const toggleSupplierList = () => {
    setSupplierListOpen(!supplierListOpen);
  };

  const supplierListColumnsObj = [
    { Header: "Vendor Code", accessor: "supplier_code" },
    { Header: "Vendor Name", accessor: "supplier_name" },
  ];
  const supplierListColumns = useMemo(
    () => supplierListColumnsObj,
    [supplierListColumnsObj]
  );
  const supplierList = useMemo(
    () => userData?.userSuppliers,
    [userData?.userSuppliers]
  );

  const [storeListOpen, setStoreListOpen] = useState(false);
  const toggleStoreList = () => {
    setStoreListOpen(!storeListOpen);
  };

  const storeListColumnsObj = [
    { Header: "Store Code", accessor: "store_code" },
    { Header: "Store Name", accessor: "store_name" },
  ];
  const storeListColumns = useMemo(
    () => storeListColumnsObj,
    [storeListColumnsObj]
  );
  const storeList = useMemo(() => userData?.userStores, [userData?.userStores]);

  const [departmentListOpen, setDepartmentListOpen] = useState(false);
  const toggleDepartmentList = () => {
    setDepartmentListOpen(!departmentListOpen);
  };

  const departmentListColumnsObj = [
    { Header: "Department Code", accessor: "department_code" },
    { Header: "Department Name", accessor: "department_name" },
  ];
  const departmentListColumns = useMemo(
    () => departmentListColumnsObj,
    [departmentListColumnsObj]
  );
  const departmentList = useMemo(
    () => userData?.userDepartments,
    [userData?.userDepartments]
  );

  const [buyerListOpen, setBuyerListOpen] = useState(false);
  const toggleBuyerList = () => {
    setBuyerListOpen(!buyerListOpen);
  };

  const buyerListColumnsObj = [
    { Header: "Buyer Code", accessor: "buyer_code" },
    { Header: "Buyer Name", accessor: "buyer_name" },
  ];
  const buyerListColumns = useMemo(
    () => buyerListColumnsObj,
    [buyerListColumnsObj]
  );
  const buyerList = useMemo(
    () => userData?.userBuyers,
    [userData?.userBuyers]
  );

  return (
    // <div className="admin-details-page-sec">
    //   <AdminSidebar />
    //   <div className="admin-details-page-body">
    //     <AdminHeader />
        <div className="my-account relative d-flex flex-col">
          <div className="my-account-title relative d-flex align-center justify-between">
            My Account
          </div>
          <div className="my-account-body relative d-flex flex-col justify-between">
            <div className="my-acc-sec relative d-flex flex-col">
              <div className="my-acc-header-sec d-flex align-center justify-between">
                <div className="h-acc-details d-flex">
                  <div className="h-acc-cnt d-flex flex-col">
                    <h3 className="m-0 d-flex">
                      {userData?.firstName} {userData?.middleName}{" "}
                      {userData?.lastName}
                    </h3>
                    <div className="h-acc-user-details d-flex align-center">
                      User ID: {userData?.id}
                    </div>
                  </div>
                </div>
                <div className="h-acc-logout">
                  <button
                    type="button"
                    className="btns logout-btn"
                    onClick={logout}
                  >
                    <span className="material-symbols-outlined">logout</span>{" "}
                    Logout
                  </button>
                </div>
              </div>
              <div className="my-acc-form relative d-flex flex-col">
                <div className="my-acc-form-list relative d-flex">
                  <div className="form-group m-0 p-0 relative d-flex flex-col align-start">
                    <label className="m-0 p-0 relative">User Name</label>
                    <span className="form-control h-42">
                      {userData?.username}
                    </span>
                  </div>
                  <div className="form-group m-0 p-0 relative d-flex flex-col align-start">
                    <label className="m-0 p-0 relative">Email</label>

                    <span className="form-control h-42">{userData?.email}</span>
                  </div>
                  <div className="form-group m-0 p-0 relative d-flex flex-col align-start">
                    <label className="m-0 p-0 relative">User Role</label>
                    <span className="form-control h-42">
                      {userData?.roleData?.role}
                    </span>
                  </div>
                  <div className="form-group m-0 p-0 relative d-flex flex-col align-start">
                    <label className="m-0 p-0 relative">First Name</label>
                    <span className="form-control h-42">
                      {userData?.firstName}
                    </span>
                  </div>
                  <div className="form-group m-0 p-0 relative d-flex flex-col align-start">
                    <label className="m-0 p-0 relative">Middle Name</label>
                    <span className="form-control h-42">
                      {userData?.middleName}
                    </span>
                  </div>
                  <div className="form-group m-0 p-0 relative d-flex flex-col align-start">
                    <label className="m-0 p-0 relative">Last Name</label>
                    <span className="form-control h-42">
                      {userData?.lastName}
                    </span>
                  </div>

                  <div className="form-group m-0 p-0 relative d-flex flex-col align-start">
                    <label className="m-0 p-0 relative">Mobile</label>
                    <span className="form-control h-42">
                      {userData?.countryCode} {userData?.mobileNumber}
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <div className="form_sec_row supplied-brand-sec">
                  <div
                    className="supplied-brand-title d-flex align-center justify-between cursor-pointer"
                    onClick={toggleSupplierList}
                  >
                    <h3>Vendor List </h3>
                    <button
                      type="button"
                      className="show-hide-btn d-flex align-center justify-center"
                    >
                      <span className="material-symbols-outlined">
                        {supplierListOpen
                          ? "keyboard_arrow_up"
                          : "keyboard_arrow_down"}
                      </span>
                    </button>
                  </div>
                  <div
                    className="supplied-b-info"
                    style={{
                      height: supplierListOpen ? `${contentHeight}px` : "0px",
                      overflow: "hidden",
                      transition: "height 0.3s ease",
                    }}
                  >
                    <div className="supplied-b-body" ref={contentRef}>
                      {userData?.userSuppliers &&
                      userData?.userSuppliers?.length > 0 ? (
                        <div
                          className="table-sec"
                          style={{
                            height: "100%",
                            overflow: "auto",
                          }}
                        >
                          <SimpleTable
                            columns={supplierListColumns}
                            data={userData?.userSuppliers ? supplierList : []}
                          />
                        </div>
                      ) : (
                        <div className="d-flex align-center justify-center">
                          <div className="no-rec-found d-flex flex-col align-center">
                            <img src="/images/no_search.svg" alt="" />
                            No Data Available
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form_sec_row supplied-brand-sec mt-4">
                  <div
                    className="supplied-brand-title d-flex align-center justify-between cursor-pointer"
                    onClick={toggleStoreList}
                  >
                    <h3>Store List </h3>
                    <button
                      type="button"
                      className="show-hide-btn d-flex align-center justify-center"
                    >
                      <span className="material-symbols-outlined">
                        {storeListOpen
                          ? "keyboard_arrow_up"
                          : "keyboard_arrow_down"}
                      </span>
                    </button>
                  </div>
                  <div
                    className="supplied-b-info"
                    style={{
                      height: storeListOpen ? `${contentHeight}px` : "0px",
                      overflow: "hidden",
                      transition: "height 0.3s ease",
                    }}
                  >
                    <div className="supplied-b-body" ref={contentRef}>
                      {userData?.userStores &&
                      userData?.userStores?.length > 0 ? (
                        <div
                          className="table-sec"
                          style={{
                            height: "100%",
                            overflow: "auto",
                          }}
                        >
                          <SimpleTable
                            columns={storeListColumns}
                            data={userData?.userStores ? storeList : []}
                          />
                        </div>
                      ) : (
                        <div className="d-flex align-center justify-center">
                          <div className="no-rec-found d-flex flex-col align-center">
                            <img src="/images/no_search.svg" alt="" />
                            No Data Available
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form_sec_row supplied-brand-sec mt-4">
                  <div
                    className="supplied-brand-title d-flex align-center justify-between cursor-pointer"
                    onClick={toggleDepartmentList}
                  >
                    <h3>Department List </h3>
                    <button
                      type="button"
                      className="show-hide-btn d-flex align-center justify-center"
                    >
                      <span className="material-symbols-outlined">
                        {departmentListOpen
                          ? "keyboard_arrow_up"
                          : "keyboard_arrow_down"}
                      </span>
                    </button>
                  </div>
                  <div
                    className="supplied-b-info"
                    style={{
                      height: departmentListOpen ? `${contentHeight}px` : "0px",
                      overflow: "hidden",
                      transition: "height 0.3s ease",
                    }}
                  >
                    <div className="supplied-b-body" ref={contentRef}>
                      {userData?.userDepartments &&
                      userData?.userDepartments?.length > 0 ? (
                        <div
                          className="table-sec"
                          style={{
                            height: "100%",
                            overflow: "auto",
                          }}
                        >
                          <SimpleTable
                            columns={departmentListColumns}
                            data={
                              userData?.userDepartments ? departmentList : []
                            }
                          />
                        </div>
                      ) : (
                        <div className="d-flex align-center justify-center">
                          <div className="no-rec-found d-flex flex-col align-center">
                            <img src="/images/no_search.svg" alt="" />
                            No Data Available
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form_sec_row supplied-brand-sec mt-4 mb-4">
                  <div
                    className="supplied-brand-title d-flex align-center justify-between cursor-pointer"
                    onClick={toggleBuyerList}
                  >
                    <h3>Buyer List </h3>
                    <button
                      type="button"
                      className="show-hide-btn d-flex align-center justify-center"
                    >
                      <span className="material-symbols-outlined">
                        {buyerListOpen
                          ? "keyboard_arrow_up"
                          : "keyboard_arrow_down"}
                      </span>
                    </button>
                  </div>
                  <div
                    className="supplied-b-info"
                    style={{
                      height: buyerListOpen ? `${contentHeight}px` : "0px",
                      overflow: "hidden",
                      transition: "height 0.3s ease",
                    }}
                  >
                    <div className="supplied-b-body" ref={contentRef}>
                      {userData?.userBuyers &&
                      userData?.userBuyers?.length > 0 ? (
                        <div
                          className="table-sec"
                          style={{
                            height: "100%",
                            overflow: "auto",
                          }}
                        >
                          <SimpleTable
                            columns={buyerListColumns}
                            data={
                              userData?.userBuyers ? buyerList : []
                            }
                          />
                        </div>
                      ) : (
                        <div className="d-flex align-center justify-center">
                          <div className="no-rec-found d-flex flex-col align-center">
                            <img src="/images/no_search.svg" alt="" />
                            No Data Available
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loader && <LoadingOverlay />}
        </div>
    //   </div>
    // </div>
  );
}
